import {Endpoint} from "@eryxcoop/appyx-comm";
import DateAdapter from "../../adapters/DateAdapter";

export default class ConfirmOrdersOnDateEndpoint extends Endpoint {
    adaptValues(date) {
        const dateAdapter = new DateAdapter();
        return {
            "date": dateAdapter.adapt(date)
        }
    }
}